import { render, staticRenderFns } from "./ModuleSetConsultation.vue?vue&type=template&id=5291e3ea&scoped=true&lang=pug&"
import script from "./ModuleSetConsultation.vue?vue&type=script&lang=js&"
export * from "./ModuleSetConsultation.vue?vue&type=script&lang=js&"
import style0 from "./ModuleSetConsultation.vue?vue&type=style&index=0&id=5291e3ea&lang=scss&scoped=true&"
import style1 from "./ModuleSetConsultation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5291e3ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextField,VTextarea})
